/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.vsmMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.vsmLists = res.data.data;
    }
  },
  [storeMutations.setVsmMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.vsmList = res.data;
    }
  },
  [storeMutations.domainMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.domain = res.data.data;
    }
  },
  [storeMutations.setDomainMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.domains = res.data;
    }
  },
};
export default {...mutations };